import { render, staticRenderFns } from "./PendingTable.vue?vue&type=template&id=2dc88640"
import script from "./PendingTable.vue?vue&type=script&lang=ts"
export * from "./PendingTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports